<template>
    <div class="container" style="margin-top: 50px;">
        <div class="row">
            <div class="col-md-6 offset-md-3 col-xs-12 text-center" v-if="loading">
                <i class="fa fa-spin fa-spinner fa-2x"></i> Loading
            </div>
            <div class="col-md-6 offset-md-3 col-xs-12" v-else>
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <img :src="account.brand_logo_large" class="img-fluid mb-3 w-100" v-if="account">
                        <img src="/Images/Merit-EHS.png" class="img-fluid mb-3 w-100" v-else>
                    </div>
                </div>
                <h4 class="pb-2 mt-3 mb-4 border-bottom"><i class="fa fa-envelope"></i> Reset Password</h4>

                <div>
                    <div :class="{ 'form-group': true, 'has-error': errors.email }" class="row">
                        <label class="col-sm-3 col-form-label text-sm-right" :class="{'text-danger': errors.email }">Email Address:</label>
                        <div class="col-sm-9">
                            <input type="email" v-model="resetInfo.email" class="form-control" :class="{'is-invalid': errors.email }" placeholder="Enter Email Address" />
                            <span v-if="errors.email" class="text-danger">
                                <template v-if="Array.isArray(errors.email)">
                                    <template v-for="error in errors.email">
                                        {{ error }}
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="errors.email == 'This password reset token is invalid.'">
                                        Your password reset link has expired. Please
                                        <router-link :to="`/password/reset?email=${resetInfo.email}`" title="Reset Password">
                                            click here
                                        </router-link>
                                        to re-send the email.
                                    </template>
                                    <template v-else>{{ errors.email }}</template>
                                </template>
                            </span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label text-sm-right" :class="{'text-danger': errors.password }">Password:</label>
                        <div class="col-sm-9">
                            <input type="password" v-model="resetInfo.password" class="form-control" :class="{'is-invalid': errors.password }" placeholder="Enter Password" />
                            <span v-if="errors.password" class="text-danger">
                                <span v-for="error in errors.password">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <div :class="{ 'form-group': true, 'has-error': errors.password_confirmation }" class="row">
                        <label class="col-sm-3 col-form-label text-sm-right" :class="{'text-danger': errors.password_confirmation }">Confirm Password:</label>
                        <div class="col-sm-9">
                            <input type="password" v-model="resetInfo.password_confirmation" class="form-control" :class="{'is-invalid': errors.password_confirmation }" placeholder="Confirm Password" />

                            <span v-if="errors.password_confirmation" class="text-danger">
                                <span v-for="error in errors.password_confirmation">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <hr/>

                    <button class="btn btn-primary" @click="resetPassword" :disabled="saving">
                        <template v-if="saving">Resetting Password <i class="fa fa-spinner fa-spin"></i></template>
                        <template v-else>Reset Password</template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                resetInfo: {
                    token: this.$route.params.token,
                    email: this.$route.query.email,
                    subdomain: (/:\/\/([^\/]+)/.exec(window.location.href)[1]).split('.')[0],
                },
                saving: false,
                loading: true,
                status: null,
                account: null,
                errors: [],
            }
        },

        methods: {

            getReset() {
                //Send it
                this.$http
                .get('password/reset', this.resetInfo)
                .then(response => {
                    //Check  it
                    if(response.data.account)
                    {
                        this.account = response.data.account;
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data

                        this.status = null;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.loading = false;
                });
            },

            resetPassword() {
                this.saving = true;

                this.$http
                .post('password/reset', this.resetInfo)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Password Reset');

                    this.errors = [];

                    // Redirect to login? homepage?
                    window.location.pathname = '/';
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data

                        this.status = null;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get it
            this.getReset();
        }
    }
</script>
